/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { Home } from '../../../../components/Icon';
import { PageHeader } from '../../../../components/PageHeader';
import { Sort } from '../../../../components/Sort';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { selectWorks } from '../../../Api/selectors';

import { changeVehicleFilter, setVehiclesSort, applyVehicleFilters, getDocumentsByType } from '../../../Vehicles/actions';

import { REQUEST_VEHICLES, REQUEST_VEHICLE_FROM_AUTOTELEX, SET_VEHICLES_SORT } from '../../../Vehicles/constants';
import {
  selectVehicleCount,
  selectVehiclePaginator,
  selectVehicles,
  selectVehicleBulkActionsList,
  selectVehicleFilter,
} from '../../../Vehicles/selectors';
import { VehicleStatusLabel } from '../../../Vehicles/components/VehicleStatusLabel';
import { setScrollPosition } from '../../../Actions/actions';
import { toggleNotification } from '../../actions';
import { Notification } from '../../../../components/Notification';
import { selectNotification } from '../../selectors';
import CardComponent from '../../../../containers/App/Components/Card/Card';
import LoadingCard from '../../../../containers/App/Components/LoadingCard/LoadingCard';

import PaginationComponent from '../../../../containers/App/Components/Pagination/Pagination';
import s from './AnalyseVehicles.module.css';

import cn from 'classnames';
import { getDate, getImgUrlExterior } from '../../../Vehicles/helpers';

import customParseFormat from 'dayjs/plugin/customParseFormat';
import { RegplateLabel } from '../../../Vehicles/components/RegplateLabel';
import { HBox } from '../../../../components/Box';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { WithInvoice } from '../../../Invoices/components/WithInvoice';
import LoadingFilters from '../../../../containers/App/Components/LoadingFilters/LoadingFilters';
dayjs.extend(customParseFormat);

const RemarkDataIconWrapper = styled.div`
  a {
    position: relative;
  }

  .alt-block {
    position: absolute;
    left: 0;
    margin-left: -100px;
    margin-top: 5px;
    top: ${props => (props.innerWidth < 768 ? '110%' : '100%')};
    z-index: 2;
    min-width: ${props => (props.innerWidth < 768 ? '150px' : '250px')};
    max-width: ${props => (props.innerWidth < 768 ? '150px' : '300px')};
    padding: 4px 8px;
    background-color: #cccccc;
    color: #6d727b;
    white-space: normal;
    text-align: left;
    border-radius: 5px;
  }
`;

const STATE = {
  sort: null,
  sort_direction: 'down',
  isShowAddModal: false,
  isShowMore: true,
  currentPage: 0,
  localPaginator: {
    limit: 50,
    offset: 0,
    itemsCount: 0,
  },
  filteredVehicles: [],
};
/* eslint-disable react/prefer-stateless-function */
class AnalyseVehiclesComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  componentDidMount() {
    if (this.locationState?.fromVehicleDetails) {
      this.props.fetch();
    }
    if (this.props.weblogin) {
      this.setState({
        localPaginator: {
          ...this.state.localPaginator,
          itemsCount: this.props.webloginVehicles.length,
        },
      });
    }
    this.props.getPhotos(result => {
      if (result?.length && result[0]?.id) {
        this.setState({ leftFrontImage: result[0] });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.notification?.isShow) {
      this._t = this.timeout(
        () => {
          this.props.toggleNotification();
        },
        5000,
        this._t,
      );
    }
    if (this.props.weblogin && prevProps.webloginVehicles !== this.props.webloginVehicles) {
      this.setState({
        localPaginator: {
          ...this.state.localPaginator,
          itemsCount: this.props.webloginVehicles.length,
        },
      });
    }
  }

  get vehicles() {
    const soldVehicles = this.props.vehicles?.filter(v => v?.outgoing_invoice_finalized === '1');

    return soldVehicles;
  }

  getFilteredVehicles(vehicles) {
    if (this.state.showSold === '1') {
      return vehicles?.filter(v => v?.rdw_tenaamstelling_date_seller_sold);
    }
    if (this.state.showSold === '2') {
      return vehicles?.filter(v => !v?.rdw_tenaamstelling_date_seller_sold);
    }

    return vehicles;
  }

  get vehiclesCount() {
    if (this.props.weblogin && Array.isArray(this.state.filteredVehicles)) {
      return this.state.filteredVehicles?.length;
    }

    return this.props.weblogin ? this.props.webloginVehicles?.length : this.props.count;
  }

  get locationState() {
    return this.props.location?.state?.state;
  }

  get noSortingTypes() {
    return ['isHome', 'regplate', 'info', 'transmission_type', 'date_expected', 'body_type'];
  }

  getTypesTosort(type) {
    let types = {
      brand_name: 'info',
      date_first_allowance: 'year',
    };

    return types[type] || type;
  }

  sortOn(field) {
    let direction = 'none';
    let sortType;

    switch (field) {
      case 'year': {
        sortType = 'date_first_allowance';
        break;
      }
      case 'b2bPrice': {
        sortType = 'financial_price_b2b_incl_vat_btpm';
        break;
      }

      default:
        sortType = field;
    }

    let order;
    if (this.props.filter?.sortType == sortType) {
      if (!this.props.filter?.order) order = 'asc';
      if (this.props.filter?.order == 'asc') order = 'desc';
    } else {
      order = 'asc';
    }
    this.setState({ direction: !order ? 'none' : order == 'asc' ? 'up' : 'down' });
    order ? this.props.setSort(sortType, order) : this.props.setSort('', '');
  }

  selectPage = newPage => {
    const newOffset = newPage * this.props.paginator?.limit ?? 0;
    this.props.setScrollPosition(null);

    this.setState(
      prev => ({
        currentPage: newPage,
      }),
      this.props.changeFilter('offset', newOffset),
    );
  };

  cols() {
    return [
      'regplate',
      'info',
      'transmission_type',
      'year',
      'price',
      'rdw_tenaamstelling_date_seller',
      'rdw_tenaamstelling_date_seller_sold',
      'rdw_tenaamstelling_date_seller_counter',
      'seller_sold',
    ];
  }

  get bulkActionItemsPage() {
    return this.state.currentPage ? this.state.currentPage + 1 : 1;
  }

  toggleDiv = () => {
    this.setState(prevState => ({
      isShowMore: !prevState.isShowMore,
    }));
  };
  filterVehicles = filterParams => {
    if (!filterParams) {
      this.setState({ filteredVehicles: this.props.webloginVehicles || [] });
      return;
    }

    const filters = filterParams.properties.reduce((acc, cur) => {
      if (cur.key === 'status') {
        acc[cur.key] = cur.value;
      } else {
        acc[cur.key] = cur.value.map(v => v.toLowerCase());
      }
      return acc;
    }, {});

    const searchString = filterParams.searchString ? filterParams.searchString.toLowerCase() : '';
    const searchWords = searchString.split(/\s+/);

    if (!this.props.webloginVehicles) {
      this.setState({ filteredVehicles: [] });
      return;
    }

    const filteredVehicles = this.props.webloginVehicles.filter(vehicle => {
      const vehicleStatus = vehicle.status;

      const matchesFilters = Object.keys(filters).every(key => {
        if (key === 'status') {
          return filters[key].length === 0 || filters[key].includes(vehicleStatus);
        } else {
          const vehicleProperty = vehicle[key] ? vehicle[key].toLowerCase() : '';
          return filters[key].length === 0 || filters[key].some(filterValue => vehicleProperty.includes(filterValue));
        }
      });

      const matchesSearchString =
        searchWords.length === 0 ||
        searchWords.every(word =>
          ['brand_name', 'model_name', 'id', 'regplate', 'vin'].some(prop =>
            vehicle[prop]
              ? vehicle[prop]
                  .toString()
                  .toLowerCase()
                  .includes(word)
              : false,
          ),
        );

      return matchesFilters && matchesSearchString;
    });

    this.setState({ filteredVehicles });
  };

  render() {
    const count = this.vehiclesCount;
    const vehicles = this.getFilteredVehicles(this.vehicles);
    const {
      currentPage,
      localPaginator: { limit },
    } = this.state;

    const startIndex = currentPage * limit;
    const endIndex = startIndex + limit;
    const vehiclesToShow = this.props.weblogin ? this.state.filteredVehicles.slice(startIndex, endIndex) : vehicles;
    const totalCount = this.props.weblogin ? this.state.filteredVehicles.length : this.props.count;

    if (window.innerWidth >= 1024 && this.props.work) {
      return (
        <>
          <div className="container-fluid p-0">
            <PageHeader
              title={
                <>
                  <Home />
                  {this.lbl('vehicle.overview.title')}
                </>
              }
            ></PageHeader>
            <LoadingFilters />
          </div>
        </>
      );
    }

    return (
      <div className="container-fluid p-0">
        {this.props.notification?.isShow == '1' && (
          <Notification>{this.lbl(`vehicle.details.bulk_action.${this.props.notification?.message}`)}</Notification>
        )}
        <PageHeader
          title={
            <>
              <Home />
              {this.lbl('vehicle.overview.title')}
              {count !== null ? <span className="label number">{count}</span> : null}
            </>
          }
        ></PageHeader>

        <HBox center vCenter gap="12">
          <ButtonComponent
            disabled={this.state.showSold === '1'}
            style={'ButtonSoftPrimary'}
            onClick={() => {
              this.setState({ showSold: '1' });
            }}
          >
            {this.lbl('company.edit.analyse.sold')}
          </ButtonComponent>
          <ButtonComponent
            disabled={this.state.showSold === '2'}
            style={'ButtonSoftPrimary'}
            onClick={() => {
              this.setState({ showSold: '2' });
            }}
          >
            {this.lbl('company.edit.analyse.not_sold')}
          </ButtonComponent>
          <span className={s.skipFilterBtn} onClick={() => this.setState({ showSold: '0' })}>
            {this.lbl('company.edit.analyse.skip')}
          </span>
        </HBox>

        {window.innerWidth >= 900 && count !== (null || 0) ? (
          <table className={cn('table', 'table-hover', 'mb-0', s.wrapper)}>
            <thead className="align-middle">
              <tr className={cn('align-middle', s.thead)}>
                <th className={s.headTh}></th>
                {this.cols().map((col, index) => (
                  <th className={s.headTh} key={`${col}-${index}`} onClick={() => this.sortOn(col)}>
                    <div className={cn('d-flex gap-2 text-muted', s.spanContainer)}>
                      {this.renderHeaderCell(col)}

                      {!this.noSortingTypes?.includes(col) && (
                        <Sort
                          direction={this.getTypesTosort(this.props.filter?.sortType) == col ? this.state.direction : 'none'}
                        />
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>{vehiclesToShow.filter(v => v).map(vehicle => this.renderRow(vehicle))}</tbody>
          </table>
        ) : (
          <>
            {vehiclesToShow
              .filter(v => v)
              .map(vehicle => (
                <div className="rows">{this.renderCard(vehicle)}</div>
              ))}
          </>
        )}

        {totalCount > limit && (
          <div className={s.pagination}>
            <PaginationComponent
              paginator={this.props.weblogin ? this.state.localPaginator : this.props.paginator}
              selectPage={this.selectPage}
            />
          </div>
        )}
      </div>
    );
  }

  renderCard = vehicle => {
    const establishmentName = "In de Wal Auto's B.V.";
    let date =
      typeof vehicle.date_first_allowance === 'number'
        ? dayjs(vehicle.date_first_allowance).format('DD-MM-YYYY')
        : dayjs(vehicle.date_first_allowance, 'DD-MM-YYYY').format('DD-MM-YYYY');
    if (date === 'Invalid Date') {
      date = vehicle.date_first_allowance;
    }
    if (this.props.work) return <LoadingCard />;
    const leftFrontImage = this.state.leftFrontImage || this.props.photos?.[0];

    return (
      <CardComponent
        key={vehicle.id}
        id={`item${vehicle.id}`}
        imgURL={`${
          leftFrontImage?.id
            ? leftFrontImage?.url
            : vehicle?.action_ws2_interior_inspection_done === '1'
            ? `${getImgUrlExterior(vehicle?.helga_id || vehicle?.id, '01')}`
            : `/public/images/placeholder.png`
        }`}
        title={
          <div className={s.cardTitle}>
            <div className={s.containerInfo}>
              <span className={s.cardInfoCar}>
                <strong>
                  {vehicle.brand_name}&nbsp;
                  {vehicle.model_name}
                </strong>
                {vehicle.power ? <> {vehicle.power} Kw</> : ''}
              </span>
              <span>{vehicle.model_info}</span>
            </div>
          </div>
        }
        onClick={e => this.handleClick(e, vehicle.id)}
        label={
          <div className={s.statusCard}>
            <VehicleStatusLabel key={vehicle.id} status={vehicle?.status}>
              {this.lbl('vehicle.property.status.' + (vehicle.status || 0))}
            </VehicleStatusLabel>
          </div>
        }
      >
        <div className={cn('text-muted', s.gridCard)}>
          <div className={s.gridCardColumn}>
            <h6 className={s.gridCardItem}>{<RegplateLabel regplate={vehicle.regplate} width="80" />}</h6>
            <h6 className={s.gridCardItem}>{date?.split?.('-').pop() ?? '-'}</h6>
            <h6 className={s.gridCardItem}>{parseInt(vehicle.mileage || '0').toLocaleString() + ' km'}</h6>
            <h6 className={s.gridCardItem}>
              {vehicle?.transmission_type?.charAt(0).toUpperCase() + vehicle?.transmission_type?.slice(1) ?? '-'}
            </h6>
          </div>

          <div className={s.gridCardColumn}>
            <h6 className={s.gridCardItem}>{vehicle?.vin ?? '-'}</h6>
            <h6 className={s.gridCardItem}>
              {vehicle?.tax_type?.charAt(0).toUpperCase() + vehicle?.tax_type?.slice(1) ?? '-'}
            </h6>
            <h6 className={s.gridCardItem}>
              {vehicle?.fuel_type?.charAt(0).toUpperCase() + vehicle?.fuel_type?.slice(1) ?? '-'}
            </h6>
            <h6 className={s.gridCardItem}>{vehicle?.id ?? '-'}</h6>
          </div>
        </div>
      </CardComponent>
    );
  };

  handleClick(event, itemId) {
    // this.props.setScrollPosition(`#item${itemId}`);
    this.to(`/vehicles/${itemId}`, event?.ctrlKey || event?.metaKey);
  }

  isHovered(bool, vehicleId) {
    this.setState({ isHover: bool, hoveredId: vehicleId });
  }

  renderRemarkText(remarks, vehicleId) {
    if (!remarks?.length) {
      return (
        <img
          style={{ cursor: 'pointer', opacity: '0.15', marginRight: '5px' }}
          src="https://vindat.indewal.nl/storage/documents/ca10dd49-aac5-4351-a014-a3cfeee9f88d.png"
          title="Remarks_109099090"
          width="18"
        />
      );
    }
    let parsedRemarks = JSON.parse(remarks);
    return (
      <RemarkDataIconWrapper innerWidth={window.innerWidth}>
        <a onMouseEnter={() => this.isHovered(true, vehicleId)} onMouseLeave={() => this.isHovered(false)}>
          <img
            className="data-remark-image"
            style={{ cursor: 'pointer', marginRight: '5px' }}
            src="https://vindat.indewal.nl/storage/documents/ca10dd49-aac5-4351-a014-a3cfeee9f88d.png"
            width="18"
          />
          {this.state.isHover && this.state.hoveredId === vehicleId && (
            <div className="alt-block">
              {parsedRemarks?.map((remark, index) => (
                <strong style={{ display: 'block' }} key={remark?.id}>{`${index + 1}. ${remark?.text}\n`}</strong>
              ))}
            </div>
          )}
        </a>
      </RemarkDataIconWrapper>
    );
  }

  renderText(text) {
    return <strong>{text}</strong>;
  }

  handleTableRowClick = (event, vehicleId) => {
    const excludeElements = ['input', 'img'];
    const targetElement = event.target.tagName.toLowerCase();
    if (!excludeElements.includes(targetElement)) {
      this.handleClick(event, vehicleId);
    }
  };

  renderRow(vehicle) {
    // console.dir(vehicle);

    return (
      <tr
        className={`align-middle ${s.thead}`}
        key={vehicle.id}
        id={`item${vehicle.id}`}
        onClick={event => this.handleTableRowClick(event, vehicle.id)}
      >
        <td className={s.bodyTd}>
          <div className={s.checkboxContainerTd}></div>
        </td>

        {this.cols().map(col => (
          <td className={s.bodyTd}>{this.renderCell(col, vehicle)}</td>
        ))}
      </tr>
    );
  }

  renderHeaderCell(col) {
    switch (col) {
      case 'transmission_type':
        return <img width="16" src="/public/images/icon_car_shift.svg" />;
        break;
      case 'regplate':
        return null;
        break;
      case 'year':
        return <img width="16" src="/public/images/calendar-symbol.svg" />;
        break;
      default:
        return this.lbl(`vehicles.overview.column.${col}`);
    }
  }

  renderCell(col, vehicle) {
    let date =
      typeof vehicle.date_first_allowance === 'number'
        ? dayjs(vehicle.date_first_allowance).format('DD-MM-YYYY')
        : dayjs(vehicle.date_first_allowance, 'DD-MM-YYYY').format('DD-MM-YYYY');

    const key = `${col}-${vehicle.id}`;
    if (date === 'Invalid Date') {
      date = vehicle.date_first_allowance;
    }

    const fn = () => {
      switch (col) {
        case 'regplate':
          return (
            <div className={cn('text-wrap', s.reglateCar)} key={key}>
              <div className={s.licensePlate}>{<RegplateLabel regplate={vehicle.regplate} width="80" />}</div>
              <div>{vehicle.vin?.substr(-6)}</div>
              <div>ID: {vehicle.id}</div>
            </div>
          );

        case 'vin':
          return vehicle.vin;

        case 'year':
          return (
            <div key={key}>
              <div style={{ fontWeight: '600' }}>{date}</div>
              <div>{parseInt(vehicle.mileage || '0').toLocaleString() + ' km'}</div>
            </div>
          );
        case 'rdw_tenaamstelling_date_seller':
          return (
            <div key={key}>
              <div style={{ fontWeight: '600' }}>{getDate(vehicle.rdw_tenaamstelling_date_seller)}</div>
            </div>
          );
        case 'rdw_tenaamstelling_date_seller_sold':
          return (
            <div key={key}>
              <div style={{ fontWeight: '600' }}>{getDate(vehicle.rdw_tenaamstelling_date_seller_sold)}</div>
            </div>
          );
        case 'rdw_tenaamstelling_date_seller_counter':
          return (
            <div key={key}>
              <div style={{ fontWeight: '600' }}>
                {vehicle?.rdw_tenaamstelling_date_seller_counter
                  ? `${vehicle.rdw_tenaamstelling_date_seller_counter} ${this.lblStr('days')}`
                  : ''}
              </div>
            </div>
          );
        case 'seller_sold':
          return (
            <div key={key}>
              <div>
                {vehicle?.rdw_tenaamstelling_date_seller_sold
                  ? this.lblStr('yes')?.toUpperCase()
                  : this.lblStr('no')?.toUpperCase()}
              </div>
            </div>
          );
        case 'info':
          return (
            <div key={key} className={s.gridContainer}>
              <div className={s.carAvatar}>
                <VehicleAvatar vehicle={vehicle} />
              </div>

              <div className={s.carInformation}>
                <div className={s.brandName}>
                  {vehicle.brand_name} {vehicle.model_name} | {vehicle.power ? <>{vehicle.power} Kw</> : ''}
                </div>
                <div className={s.modelInfo}>{vehicle.model_info}</div>
              </div>
            </div>
          );
          break;

        case 'transmission_type':
          try {
            let t = vehicle.transmission_type?.toLowerCase();
            if (t == 'handmatig' || t.toLowerCase().indexOf('m') === 0) t = 'M';
            if (t == 'automatic') t = 'A';
            if (t == 'automaat') t = 'A';

            return (
              <div>
                <div style={{ fontWeight: '600' }}>{t}</div>
                <div>{vehicle.base_color == 'Niet van toepassing' ? '' : vehicle.base_color ?? ''}</div>
              </div>
            );
            return t;
          } catch (e) {
            return vehicle.transmission_type;
          }

        case 'price':
          return (
            <div key={key}>
              <div style={{ fontWeight: '600' }}>
                <WithInvoice invoiceId={vehicle?.outgoing_invoice} propertyNamePrice={'financialTotalAmount'} />
              </div>
              <div>{vehicle.tax_type}</div>
            </div>
          );
          return;

        default:
          return vehicle[col];
      }
    };
    return (
      <div className={`col-${col}`} key={`${col}-${vehicle.id}`}>
        {fn()}
      </div>
    );
  }
}

AnalyseVehiclesComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehicles: selectVehicles(),
    filter: selectVehicleFilter(),
    count: selectVehicleCount(),
    paginator: selectVehiclePaginator(),
    bulkActionsList: selectVehicleBulkActionsList(),
    notification: selectNotification(),
    work: selectWorks([REQUEST_VEHICLES, REQUEST_VEHICLE_FROM_AUTOTELEX]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(changeVehicleFilter('searchString', ''));
    },
    changeFilter: (name, value) => {
      dispatch(changeVehicleFilter(name, value));
    },

    getPhotos(callback) {
      dispatch(getDocumentsByType(ownProps.vehicle?.id, 'photo_interior_general_0left_front', callback));
    },

    setScrollPosition(pos) {
      dispatch(setScrollPosition(pos));
    },
    toggleNotification() {
      dispatch(toggleNotification('0'));
    },
    async setSort(type, order) {
      try {
        const result = await dispatch(setVehiclesSort(type, order));
        if (result?.type == SET_VEHICLES_SORT) {
          dispatch(applyVehicleFilters());
        }
      } catch (e) {}
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const AnalyseVehicles = compose(withConnect, withRouter, injectIntl)(AnalyseVehiclesComp);
